import { MediaType } from './MediaType';

export type AssetInfo = {
  id: string;
  filename: string;
  uri: string;
  mediaType: MediaType;
  width: number;
  height: number;
  duration: number | null;
  creationTime: number | null;
  modificationTime: number | null;
};
